import { toDateString } from '@comparit/shared';
import type { SachPersonlicheAngaben } from '../../interfaces';
import type { ZurPersonStepForms } from './zur-person-form.service';

export const mapZurPersonToDto = (value: ZurPersonStepForms): SachPersonlicheAngaben => ({
  ...value.step7,
  geburtsdatum: toDateString(value.step7.geburtsdatum) || null,
});
